import React from "react";
import PropTypes from "prop-types";
import { Portal } from "react-portal";
import PureWindow from "components/ui/modal/pure-window";

const ActionModal = ({ title, onClose, children }) => (
  <Portal>
    <PureWindow title={title} onXClick={onClose}>
      <div className="patient-outreach-action-modal">{children}</div>
    </PureWindow>
  </Portal>
);

ActionModal.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

export default ActionModal;
